import { render, staticRenderFns } from "./TransactionsFilterSummary.vue?vue&type=template&id=db5de19c&scoped=true&lang=pug&"
import script from "./TransactionsFilterSummary.vue?vue&type=script&lang=ts&"
export * from "./TransactionsFilterSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5de19c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
